import { compose, pure } from 'recompose';

import ButtonClose from './buttonClose';

const enhance = compose(
  pure,
);
export default enhance(ButtonClose);
